export const READY_TO_CONNECT = 'READY_TO_CONNECT' as const;
export const IS_CONNECTING = 'IS_CONNECTING' as const;
export const IS_CONNECTED = 'IS_CONNECTED' as const;

export type ConnectState = typeof READY_TO_CONNECT | typeof IS_CONNECTING | typeof IS_CONNECTED;

export type State = {
	connectState: ConnectState;
	selectedWorkspaceUuid: string;
};
